import React, {useEffect, useState, ReactElement, ComponentType} from 'react';
import {useLocation} from 'react-router-dom';
import {AllUsersCollegeSearchBar} from 'shared/college-search-bar/containers';
import Navbar from 'src/components/Navbar';
import {withFeatureFlags} from 'src/hooks/useFeatureFlags';
import {FeatureFlags} from 'src/services/FeatureFlagService';
import urls from 'src/utils/urls';
import {NavbarUserInfo} from '../../../components/Navbar/Navbar';
import {CTAButtonProps} from '../../../components/Navbar/NavbarCTAButton';
import UserService from '../../../services/UserService';

const menuItems = [
  {path: '/portfolio', title: 'Portfolio', routed: true},
  {path: '/checklist', title: 'Checklist', routed: true},
  {path: '/colleges/my-list', title: 'Colleges', routed: true},
  {path: '/videos', title: 'Videos', routed: true},
];

interface StudentAvatarData {
  firstName: string;
  lastName: string;
  photo: string;
}

const TransferNavbar = ({
  featureFlags: {studentMessaging},
}: {
  featureFlags: FeatureFlags;
}): ReactElement => {
  const location = useLocation();
  const [userInfo, setUserInfo] = useState<NavbarUserInfo>({});
  const avatarMenuItems = [
    ...(studentMessaging ? [{path: '/messages', title: 'Messages', routed: true}] : []),
    {path: '/account-settings', title: 'Account Settings', routed: true},
    {path: 'https://help.raise.me/hc/en-us', title: 'Help', newTab: true, routed: false},
    {path: urls.logout, title: 'Sign Out', routed: false},
  ];

  useEffect(() => {
    // using photo instead of image so that if they haven't set a photo the component will fall back to the initials
    UserService.getData<StudentAvatarData>(['firstName', 'lastName', 'photo']).then(
      ({firstName, lastName, photo}) => {
        setUserInfo({firstName, lastName, image: photo});
      }
    );
  }, []);

  const ctaButtons: CTAButtonProps[] = [
    {
      path: `${location.pathname}/invite/create`,
      title: 'Invite',
      ariaLabel: 'Invite (opens a dialog)',
      routed: true,
    },
  ];

  return (
    <Navbar
      menus={menuItems}
      avatarMenuItems={avatarMenuItems}
      ctaButtons={ctaButtons}
      SearchBar={<AllUsersCollegeSearchBar />}
      userInfo={userInfo}
      showNotificationBell
    />
  );
};

export default withFeatureFlags(
  TransferNavbar as ComponentType<{featureFlags: FeatureFlags}>,
  ['studentMessaging'],
  false
);
